import { connect } from 'react-redux';
import currentSessionIdHOC from './id';

function mapStateToProps(state, ownProps) {
  const { _session } = state.restricted;
  const { currentSessionId } = ownProps;
  const currentSession =
    (_session.session_proxy && _session.session_proxy[currentSessionId]) ||
    undefined;
  return { currentSession };
}

export default function(component) {
  return currentSessionIdHOC(connect(mapStateToProps)(component));
}



// WEBPACK FOOTER //
// ./src/connectHOCs/Sessions/currentSession/index.js